export default __webpack_public_path__ + "static/6640-5e3225875a16e81750f3f008c0a205df.jpg";